import { t } from "i18next";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import moment from 'moment';
import { Button, Form } from "react-bootstrap";
import { Team } from "../../../../interfaces/team";
import { getTeam } from "../../../../services/team";
import { getClubOptions } from "../../../../services/club";
import { Club } from "../../../../interfaces/club";
import { Modality } from "../../../../interfaces/modality";
import { Category } from "../../../../interfaces/category";
import { getModalityOptions } from "../../../../services/modality";
import { getCategoryOptions } from "../../../../services/category";
import { ManagementTeamDelete } from "./team-delete";
import { ManagementTeamNew } from "./team-new";
import { ManagementTeamEdit } from "./team-edit";
import { TeamAthletes } from "../../common/team/team-athletes";
import { ManagementTeamStaff } from "./team-staff";
import { Link } from "react-router-dom";
import { tableStyles, getPaginationOptions } from "../../../../util/data-table";

export function ManagementTeamList() {
    const [teams, setTeams] = useState<Team[]>([]);
    const [clubs, setClubs] = useState<Club[]>([]);
    const [modalities, setModalities] = useState<Modality[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showAthletes, setShowAthletes] = useState(false);
    const [showStaff, setShowStaff] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    
    const CustomDate = (row: any ) => (
        <span>
            { moment(row.row.changed_at).format("DD/MM/YYYY HH:mm") }
        </span>
    );
    
    const CustomActions = (row: any) => (
        <span>
            {/*<a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>*/}
            <a href="#" className="icon-link athletes" title={ t('athletes') } onClick={ handleAthletes } data-id={ row.row.id }>
                <i className="bi bi-people"></i>
            </a>
            <a href="#" className="icon-link astaff" title={ t('Coaches') } onClick={ handleStaff } data-id={ row.row.id }>
                <i className="bi bi-person-check"></i>
            </a>
            {/*<a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>*/}
        </span>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'name',
            name: t("Name"),
            selector: (row: any) => <Link className="team-link" to={ '/teams/' + row.id + '/view' } title={row.name}>{row.name}</Link>,
            sortable: true
        },
        {
            id: 'club_name',
            name: t('club'),
            selector: (row: any) => row.club_name,
            sortable: true
        },
        {
            id: 'modality_name',
            name: t('modality'),
            selector: (row: any) => row.modality_name,
            sortable: true
        },
        {
            id: 'category_name',
            name: t('category'),
            selector: (row: any) => row.category_name,
            sortable: true
        },
        {
            id: 'changed_at',
            name: t('changed_at'),
            selector: (row: any) => row.changed_at,
            sortable: true,
            cell: (row: any) => <CustomDate row={row} />,
        },
        {
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }

    ];

    useEffect(() => {
         getClubOptions()
            .then(response => {
                setClubs(response.data);
            })
            .catch(error => {
                console.log(error);
            });

        getModalityOptions()
            .then(response => {
                setModalities(response.data);
            })
            .catch(error => {
                console.log(error);
            });

        getCategoryOptions()
            .then(response => {
                setCategories(response.data);
            })
            .catch(error => {
                console.log(error);
            });

        getTeam()
            .then(response => {
                setTeams(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club_id.value;
        const modality = event.target.modality_id.value;
        const category = event.target.category_id.value;

        getTeam(s, club, modality, category)
            .then(response => {
                setTeams(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Team) => {
        const newTeams = [
            s,
            ...teams
        ];
        setTeams(newTeams);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newTeams = teams.filter((m: Team) => m.id != id);
        setTeams(newTeams);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedTeam: Team) => {
        setSelectedId(0);
        const newTeams = teams.map((m: Team) => {
            if (m.id == changedTeam.id) {
                return changedTeam;
            } else {
                return m;
            }
        });
        setTeams(newTeams);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handleAthletes = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowAthletes(true);
    }

    const handleAthletesOnSave = (changedTeam: Team) => {
        setSelectedId(0);
        /*const newTeams = teams.map((m: Team) => {
            if (m.id == changedTeam.id) {
                return changedTeam;
            } else {
                return m;
            }
        });
        setTeams(newTeams);*/
        setShowAthletes(false);
    }

    const handleAthletesOnClose = () => {
        setSelectedId(0);
        setShowAthletes(false);
    }

    const handleStaff = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowStaff(true);
    }

    const handleStaffOnSave = (changedTeam: Team) => {
        setSelectedId(0);
        /*const newTeams = teams.map((m: Team) => {
            if (m.id == changedTeam.id) {
                return changedTeam;
            } else {
                return m;
            }
        });
        setTeams(newTeams);*/
        setShowStaff(false);
    }

    const handleStaffOnClose = () => {
        setSelectedId(0);
        setShowStaff(false);
    }

    return (
        <div className="teams-list-container">
            <h1>
                { t('teams')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="search" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="club_id">
                        <Form.Select aria-label={ t("club") }>
                            <option value="">{ t("select_club") }</option>
                            { clubs.map((c: Club) => {
                                return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                            })}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="modality_id">
                        <Form.Select aria-label={ t("modality") }>
                            <option value="">{ t("select_modality") }</option>
                            { modalities.map((m: Modality) => {
                                return <option key={ 'modality-' + m.id } value={ m.id }>{ m.name }</option>;
                            })}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="category_id">
                        <Form.Select aria-label={ t("category") }>
                            <option value="">{ t("select_category") }</option>
                            { categories.map((c: Category) => {
                                return <option key={ 'category-' + c.id } value={ c.id }>{ c.name }</option>;
                            })}
                        </Form.Select>
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="table-container">
                <DataTable
                    columns={ columns }
                    data={teams}
                    // selectableRows={ true }
                    // selectableRowsHighlight={ true }
                    responsive={ true }
                    striped={ true }
                    highlightOnHover={ true }
                    defaultSortFieldId={ 'changed_at' }
                    defaultSortAsc={ false }
                    pagination={ true }
                    customStyles={ tableStyles }
                    paginationComponentOptions={ getPaginationOptions() }
                />
            </div>            
            {/*<a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a> */}
            {/* showAddNew &&
                <ManagementTeamNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            */}
            {/* showDelete && (selectedId != 0) &&
                <ManagementTeamDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            */}
            {/* showEdit && (selectedId != 0) &&
                <ManagementTeamEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            */}
            { showAthletes && (selectedId != 0) &&
                <TeamAthletes id={ selectedId } onSave={ handleAthletesOnSave } onClose={ handleAthletesOnClose } />
            }
            { showStaff && (selectedId != 0) &&
                <ManagementTeamStaff id={ selectedId } onSave={ handleStaffOnSave } onClose={ handleStaffOnClose } />
            }
        </div>

    )
}
